/**
 * MaturityLegend — the 4-bucket maturity distribution shown next to the "Assets"
 * heading: 规模化 12 · 打法期 15 · 建设期 19 · 探索期 10.
 * Swatch = the pastel maturity fill (MATURITY_OVERVIEW_COLOR) — the SAME palette as
 * the swimlane card backgrounds, so a legend entry's color matches its cards.
 * Only the bucket COUNT is shown; the this-month delta (+N) is intentionally not
 * displayed (byMaturity still computes newThisMonth, just unused here).
 *
 * Display order in Figma is SCALING→…→EXPLORING (most mature first); byMaturity()
 * returns EXPLORING→SCALING, so we reverse for display.
 */
import { MATURITY_OVERVIEW_COLOR, MATURITY_LABEL } from '../../../utils/maturity';
import type { MaturityBucket } from '../utils/assetGrouping';

/** Figma appends 期 to the base label (探索→探索期). SCALING stays 规模化. */
const STAGE_SUFFIX: Record<string, string> = {
  EXPLORING: '期',
  BUILDING: '期',
  PLAYBOOK: '期',
  SCALING: '',
};

export default function MaturityLegend({ buckets }: { buckets: MaturityBucket[] }) {
  const display = [...buckets].reverse(); // SCALING first
  return (
    <div className="ivt-assets-legend" aria-label="成熟度分布">
      {display.map((b) => (
        <span className="ivt-assets-legend__item" key={b.maturity}>
          <span
            className="ivt-assets-legend__swatch"
            style={{ background: MATURITY_OVERVIEW_COLOR[b.maturity] }}
          />
          {MATURITY_LABEL[b.maturity]}
          {STAGE_SUFFIX[b.maturity]} {b.count}
        </span>
      ))}
      <span className="ivt-assets-legend__hint">
        <span className="ivt-assets-legend__newbar" /> 绿条表示 New Assets
      </span>
    </div>
  );
}
